<template>
  <div id="app">
    <Header/>
    <div class="ad">
      <a class="pc" href="http://h.accesstrade.net/sp/cc?rk=0100lkaa00iumu" rel="nofollow" target="_blank"><img src="https://h.accesstrade.net/sp/rr?rk=0100lkaa00iumu" alt="U-NEXT" border="0" /></a>
    </div>
    <WhatPitacoin v-if="!this.isDoc" />
    <router-view/>
    <QA v-if="!this.isDoc" />
    <Chat/>
    <Footer/>
  </div>
</template>

<script>
import Ad1 from './components/ad/Ad1'
import QA from './components/QA'
import Chat from './components/Chat'
import WhatPitacoin from './components/WhatPitacoin'
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'App',
  components: {
    QA,
    Chat,
    WhatPitacoin,
    Header,
    Footer,
    Ad1
  },
  data: function () {
    return {
      isDoc: false
    }
  },
  watch: {
    '$route': function (to, from) {
      if (to.path.match(/^\/doc/)) {
        this.isDoc = true
      } else {
        this.isDoc = false
      }
    }
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", YuGothic, "ヒラギノ角ゴ ProN W3", Hiragino Kaku Gothic ProN, Arial, "メイリオ", Meiryo, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
body{
  background: #FF9500;
  padding: 0;
  margin: 0;
}
.container{
  width: 712px;
  margin: 0 auto;
  padding-top: 48px;
  padding-bottom: 48px;
}
.container.box{
  background: #fff;
  border-radius: 20px;
  margin-bottom: 60px;
}
.ad{
  text-align: center;
}
.ad img{
  max-width: 100%;
}
.grecaptcha-badge{
  display: none;
}
@media all and (max-width: 740px) {
  .container{
    width: 95vw;
  }
  .container.box{
    margin-bottom: 40px;
  }
}
@media all and (max-width: 480px) {
  .pc{
    display: none;
  }
  .container{
    padding-top: 32px;
    padding-bottom: 20px;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
  }
  .container.box{
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue